<div class="align-with-nav">
    <h1>Not found</h1>
    <p>Sorry, but the resource you are looking for was not found.</p>
</div>